import { render, staticRenderFns } from "./PreviewCasesSlider.vue?vue&type=template&id=049ccf30&"
import script from "./PreviewCasesSlider.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PreviewCasesSlider.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./PreviewCasesSlider.vue?vue&type=style&index=0&id=049ccf30&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('049ccf30')) {
      api.createRecord('049ccf30', component.options)
    } else {
      api.reload('049ccf30', component.options)
    }
    module.hot.accept("./PreviewCasesSlider.vue?vue&type=template&id=049ccf30&", function () {
      api.rerender('049ccf30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/DoctorCases/components/PreviewCasesSlider.vue"
export default component.exports